export default {"src":"/_next/static/media/JPM.ca0d70ef.svg","height":18,"width":18};